import React, {useEffect, useRef} from 'react';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import styles from './index.module.scss'

const HeaderNotification = (props) => {
  const {compData} = props;
  const marqueeRef = useRef(null);

  useEffect(() => {
    const marqueeElement = marqueeRef.current;
    const containerWidth = marqueeElement.offsetWidth;
    const textWidth = marqueeElement.scrollWidth;

    const animationDuration = textWidth / 50; // Adjust the scrolling speed

    marqueeElement.style.animationDuration = `${animationDuration}s`;
  }, []);

  return (
    <div className={styles.marqueeContainer}>
      <div className={styles.marqueeText} ref={marqueeRef}>
        {
            compData.map((item, key) => (
              <span key={key}><div dangerouslySetInnerHTML={{ __html: item?.content?.rendered }} /></span>
            ))
        }
          </div>
    </div>
  );
};

export default HeaderNotification;
